var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-joinlib_selectloading text-center text-8c" },
    [
      _vm.loading
        ? _c("yxtf-svg", {
            staticClass: "v-mid",
            attrs: { width: "20px", height: "20px", "icon-class": "loading" },
          })
        : _c("label", { class: { "mt10 mb24": _vm.emptyText } }, [
            _vm._v(
              _vm._s(
                _vm.emptyText ||
                  _vm.$t("pc_biz_lbl_nosearch" /** 暂无搜索内容 */)
              )
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }